import TransferCertificatePage from "../components/pages/TransferCertificate";

export default TransferCertificatePage;
